import { useState, useEffect } from 'react';
import util from '../../../utiles/miniUtiles';
import { Badge } from 'react-bootstrap';

const NotificationContent = () => {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [filters, setFilters] = useState({ userId: '', type: '', status: '' });
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const fetchNotifications = async () => {
        setLoading(true);
        try {
            const { data } = await util.axios.get('/notification_tracker', {
                params: { userId: filters.userId, type: filters.type, status: filters.status, page, limit: 10 },
            });

            setNotifications(data.notifications);
            setTotalPages(data.pages);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, [filters, page]);

    interface Filters {
        userId: string;
        type: string;
        status: string;
    }

    interface Notification {
        id: string;
        userId: string;
        accountName: string;
        accountEmail: string;
        type: string;
        activity: string;
        recipient: string;
        status: string;
        message: string;
        createdAt: string;
        sentAt?: string;
    }

    const handleFilterChange = (key: keyof Filters, value: string) => {
        setFilters((prev) => ({ ...prev, [key]: value }));
        setPage(1);
    };

    const handlePageChange = (newPage: number) => {
        if (newPage > 0 && newPage <= totalPages) setPage(newPage);
    };

    const handleStatus = (status: string) => {
        switch (status) {
            case 'PENDING':
                return <Badge variant='warning'>Pending</Badge>;
            case 'SENT':
                return <Badge variant='success'>Sent</Badge>;
            case 'FAILED':
                return <Badge variant='danger'>Failed</Badge>;
            default:
                return <Badge variant='secondary'>Unknown</Badge>;
        }
    }

    const formatDateToClientTimezone = (dateString: string) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleString();
    };

    return (
        <div>
            <div className='d-flex w-50'>
                <input
                    className='form-control'
                    type="text"
                    placeholder="Name or Email"
                    value={filters.userId}
                    onChange={(e) => handleFilterChange('userId', e.target.value)}
                />
                <select
                    className='form-control'
                    value={filters.type}
                    onChange={(e) => handleFilterChange('type', e.target.value)}
                >
                    <option value="">All Types</option>
                    <option value="SMS">SMS</option>
                    <option value="EMAIL">Email</option>
                </select>
                <select
                    className='form-control'
                    value={filters.status}
                    onChange={(e) => handleFilterChange('status', e.target.value)}
                >
                    <option value="">All Statuses</option>
                    <option value="PENDING">Pending</option>
                    <option value="SENT">Sent</option>
                    <option value="FAILED">Failed</option>
                </select>
            </div>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <table className='table table-condensed'>
                    <thead>
                        <tr className='text-center'>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Type</th>
                            <th>Activity</th>
                            <th>Status</th>
                            <th>Created At</th>
                            <th>Sent At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {notifications && notifications?.map((n) => (
                            <tr className='text-center' key={n.id}>
                                <td>{n.id}</td>
                                <td>{n.accountName}</td>
                                <td>{n.accountEmail}</td>
                                <td><Badge variant='info'>{n.type}</Badge></td>
                                <td><Badge variant='primary'>{n.activity}</Badge></td>
                                <td>{handleStatus(n.status)}</td>
                                <td>{formatDateToClientTimezone(n.createdAt)}</td>
                                <td>{formatDateToClientTimezone(n.sentAt || 'N/A')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            <div className='d-flex justify-content-center'>
                <button className='btn btn-sm btn-primary' onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
                    Previous
                </button>
                <span className='pl-3 pr-3'>
                    Page {page} of {totalPages}
                </span>
                <button className='btn btn-sm btn-primary' onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
                    Next
                </button>
            </div>
        </div>
    );
};

export default NotificationContent;
